/* eslint-disable import/extensions */
import theme from 'common/theme'
import styled from 'styled-components'

import IconStar from './IconStar'

const Container = styled.div`
  display: flex;
  align-items: center;
`

const BackStarsDiv = styled.div`
  display: flex;
  position: relative;
  top: 0;
  color: ${theme.colors.gray};
  font-size: 9px;
`

const FrontDiv = styled.div`
  display: flex;
  position: absolute;
  top: 0;
  overflow: hidden;
  width: ${(props) =>
    `${
      props.rating !== 0
        ? ((Math.round((props.rating * 10) / 5) * 5) / 10) * 20 - 1
        : 0
    }%`};
  color: ${theme.colors.orangeYellow};
  font-size: 9px;
`

interface IRating {
  rating: number
}

function Rating({ rating }: IRating): JSX.Element {
  return (
    <>
      <Container data-testid="rating-component">
        <BackStarsDiv>
          <IconStar />
          <IconStar />
          <IconStar />
          <IconStar />
          <IconStar />
          <FrontDiv rating={rating}>
            <IconStar />
            <IconStar />
            <IconStar />
            <IconStar />
            <IconStar />
          </FrontDiv>
        </BackStarsDiv>
      </Container>
    </>
  )
}

export default Rating
